import { axios } from "@app/app/services/axios";
import { IPropertyGroup } from "@app/propertyGroup/types";

export const getPropertyGroup = async (propertyGroupId: string, page: number): Promise<IPropertyGroup> => {
    const response = await axios.get<IPropertyGroup>(`/property_groups/${propertyGroupId}?page=${page}`);

    return response.data;
};
